/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Back_To_DashboardInputs */

const en_admin_back_to_dashboard = /** @type {(inputs: Admin_Back_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const zh_admin_back_to_dashboard = /** @type {(inputs: Admin_Back_To_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制台`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Admin_Back_To_DashboardInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_back_to_dashboard = /** @type {((inputs?: Admin_Back_To_DashboardInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Back_To_DashboardInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_back_to_dashboard(inputs)
	return zh_admin_back_to_dashboard(inputs)
});
export { admin_back_to_dashboard as "admin.back_to_dashboard" }